export default "__VITE_ASSET__DiMD_WvE__"